import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "all-page" }
const _hoisted_2 = { class: "tab-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ManagementHeaderBar = _resolveComponent("ManagementHeaderBar")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_AiPortalTab = _resolveComponent("AiPortalTab")!
  const _component_AiPortalModel = _resolveComponent("AiPortalModel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createVNode(_component_ManagementHeaderBar, { index: '/aiportalManage' })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_el_tabs, {
          modelValue: $setup.activeTab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.activeTab) = $event)),
          type: "card",
          class: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('AiPortalSetting.AIPm'),
              name: "portal"
            }, null, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('AiPortalSetting.MIM'),
              name: "other"
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      ($setup.activeTab === 'portal')
        ? (_openBlock(), _createBlock(_component_AiPortalTab, { key: 0 }))
        : _createCommentVNode("", true),
      ($setup.activeTab === 'other')
        ? (_openBlock(), _createBlock(_component_AiPortalModel, { key: 1 }))
        : _createCommentVNode("", true)
    ])
  ]))
}